import "./ministat.css"

export function MiniStatCard({
  value,
  title,
  subtitle,
  tone = "neutral",
}) {
  return (
    <div className={`ss-ministat ss-ministat--${tone}`}>
      <div className="ss-ministat__value">{value}</div>

      <div className="ss-ministat__text">
        <div className="ss-ministat__title">{title}</div>
        {subtitle && (
          <div className="ss-ministat__sub">{subtitle}</div>
        )}
      </div>
    </div>
  );
}

export function MiniStatGrid({ children }) {
  return <div className="ss-ministatGrid">{children}</div>;
}
